module.exports = __webpack_public_path__ + "static/img/pw.20a1d020.svg";